'use strict';

angular.module('licensure.services')
    .factory('ProcessStatuses', ['$http', '$q', function ($http, $q) {
        return {
            get: function (license_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/processstatuses', {
                    params: {
                        license_id: license_id
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/processstatuses/' + id, {
                    params: {

                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

                return d.promise;
            }
        }
    }])
;